var _style, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarbohydrateResponse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#AA1917;}\n\t.st1{fill:#ECB880;}\n\t.st2{fill:#E4A056;}\n\t.st3{fill:#FFE8B6;}\n\t.st4{fill:#2A384F;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.3,183.2c42.8,0,77.6-34.4,77.6-76.9c0-42.4-34.7-76.9-77.6-76.9s-77.6,34.4-77.6,76.9 C28.7,148.7,63.5,183.2,106.3,183.2"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M151.4,90.8c0-11.4-11.1-20.7-25.1-21.2v-0.1H86.3v0.1c-13.9,0.5-25.1,9.8-25.1,21.2c0,4.7,1.9,9,5,12.5v31.4 c0,5.5,4.5,10,10,10l0,0h60.1c5.5,0,10-4.5,10-10l0,0v-31.4C149.5,99.8,151.4,95.5,151.4,90.8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.8,
    y: 103.3,
    className: "st2",
    width: 37.6,
    height: 3.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M113.8,90.8c0-8.7-8.9-15.8-20-16.3c-0.4,0-5.8,0-6.3,0c-11.8,0-21.3,7.3-21.3,16.3c0,4,1.9,7.7,5,10.5v30.9 c0,4.2,3.4,7.5,7.5,7.5l0,0h22.6c4.2,0,7.5-3.4,7.5-7.5l0,0v-30.9C111.9,98.5,113.8,94.8,113.8,90.8"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M86,122.9c-0.2-0.5-0.5-1-0.6-1.6c-2.3-8.1-4.5-16.2-6.8-24.2c-0.1-0.4-0.1-0.9,0-1.3c0.3-0.9,1.2-1.3,2.1-1 c0.2,0.1,0.4,0.2,0.6,0.3c2.4,1.3,4.8,2.6,7.3,3.9c0.2,0.1,0.4,0.2,0.6,0.3c0.5-0.8,1-1.5,1.5-2.2c2.5-3.7,5.7-6.8,9.6-9.1 c8.2-4.9,16.9-6,26.1-3.2c1.8,0.6,3.6,1.5,5.3,2.3c0.8,0.4,1.2,1.1,1,1.9c-0.2,0.8-0.8,1.3-1.8,1.3c-3.7,0.1-7.2,0.8-10.6,2.2 c-4.8,2-8.8,5.1-11.8,9.3c-1.3,1.9-2.4,3.9-3.7,5.9c0.3,0.2,0.5,0.3,0.6,0.4c2.5,1.4,5,2.7,7.5,4.1c1,0.5,1.3,1.2,1.1,2.1 c-0.2,0.7-0.7,1-1.3,1.2c-2.5,0.8-5,1.6-7.5,2.3c-5.6,1.8-11.2,3.5-16.8,5.3c-0.5,0.1-1,0.2-1.5,0.3C86.5,123.2,86.3,123,86,122.9z "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarbohydrateResponse);
export default __webpack_public_path__ + "static/media/Carbohydrate_Response.d834f4ab16cbb3a9ec25e2aa46a572b2.svg";
export { ForwardRef as ReactComponent };